module.exports = __webpack_public_path__ + "media/images/lb/365-79b6c4ee7075c8171ecc9784142cfbf3.svg";